import {Helmet} from "react-helmet-async";
import {CmmnHeader} from "../components/common/CmmnHeader";
import {Sub_top_002} from "../const/ConstImages";
import React, {useEffect} from "react";
import {PaymentSuccessBody} from "../components/payment/PaymentSuccessBody";

export const PaymentSuccess = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <title>Purchase M-Coin</title>
                <meta name="description" content="Success Purchase M-Coin" />
            </Helmet>
            <CmmnHeader
                backgroundImg={Sub_top_002}
                title="M-coin Purchase Successfully"
                subTitle="Aika Online uses M-coin as its currency for the purchase of in-game items"
            />
            <PaymentSuccessBody />
        </>
    )
}